import { Component, OnInit, Inject, OnDestroy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material";
import { interval, Subscription } from 'rxjs';

@Component({
  selector: "token-expired-dialog",
  templateUrl: "./token-expired-dialog.component.html",
  styleUrls: ["./token-expired-dialog.component.scss"]
})
export class TokenExpiredDialogComponent {

  constructor(public dialogRef: MatDialogRef<TokenExpiredDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  closeAction() {
    this.dialogRef.close();
  }
}
